import {useEffect, useState} from 'react';
import {toDataURL} from 'qrcode';
import './TotpQr.css';

const TotpQr = ({value}) => {
    const [src, setSrc] = useState('');

    useEffect(() => {
        let cancelled = false;
        if (!value) {
            setSrc('');
            return undefined;
        }
        toDataURL(value, {
            width: 168,
            margin: 1,
            errorCorrectionLevel: 'M',
        }).then((url) => {
            if (!cancelled) setSrc(url);
        }).catch(() => {
            if (!cancelled) setSrc('');
        });
        return () => {
            cancelled = true;
        };
    }, [value]);

    if (!src) {
        return null;
    }

    return (
        <div className="totp-qr">
            <img src={src} alt="QR-код для Google Authenticator" width={168} height={168}/>
            <p className="totp-qr__caption">Якщо зручніше камерою — відскануйте цей код</p>
        </div>
    );
};

export default TotpQr;
